import React from "react";
import '../../App.css'
import ContemporaryCard from "../ContemporaryCard";
import Roots from "../Roots";
export default function Contemporary(){
    return (
        <>
            <ContemporaryCard />
            <Roots />
        </>
    )
}